/* GENERATED FILE - DO NOT EDIT! */
define(['underscore'], function(_) {
  return function(context) {
    var __t, __p = '',
      __j = Array.prototype.join,
      print = function() {
        __p += __j.call(arguments, '');
      };
    __p += '<div is="instant-notification" class="instant-notification">';
    if (context.icon) {
      __p += '' +
        ((__t = (context.icon)) == null ? '' : __t) +
        '';
    }
    __p += '<p>' +
      ((__t = (context.message)) == null ? '' : __t) +
      '</p><div class="instant-notification__close glyph glyph-small glyph-cross-grey"></div></div>';
    return __p;
  }
});